"use strict";

exports.__esModule = true;
exports.calculatePreferencesViewForAppointment = exports.PreferenceType = exports.DisplayTarget = void 0;
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _getQueryParams = require("../getQueryParams");
let PreferenceType = exports.PreferenceType = /*#__PURE__*/function (PreferenceType) {
  PreferenceType["STAFF_MEMBER"] = "STAFF_MEMBER";
  PreferenceType["DYNAMIC_PRICE"] = "DYNAMIC_PRICE";
  PreferenceType["ADD_ONS"] = "ADD_ONS";
  PreferenceType["LOCATION"] = "LOCATION";
  return PreferenceType;
}({});
let DisplayTarget = exports.DisplayTarget = /*#__PURE__*/function (DisplayTarget) {
  DisplayTarget["PREFERENCES_MODAL"] = "PREFERENCES_MODAL";
  DisplayTarget["CALENDAR"] = "CALENDAR";
  DisplayTarget["NONE"] = "NONE";
  return DisplayTarget;
}({});
const calculatePreferencesViewForAppointment = params => {
  const staffMemberDisplay = calculateStaffMemberDisplay(params);
  const locationDisplay = calculateLocationDisplay(params);
  const addOnsDisplay = calculateAddOnsDisplay(params);
  const dynamicPriceDisplay = calculateDynamicPriceDisplay({
    ...params,
    addOnsDisplay
  });
  return {
    [PreferenceType.STAFF_MEMBER]: staffMemberDisplay,
    [PreferenceType.LOCATION]: locationDisplay,
    [PreferenceType.DYNAMIC_PRICE]: dynamicPriceDisplay,
    [PreferenceType.ADD_ONS]: addOnsDisplay
  };
};
exports.calculatePreferencesViewForAppointment = calculatePreferencesViewForAppointment;
const calculateStaffMemberDisplay = ({
  service,
  bookingsSettings,
  serviceOptionsAndVariants,
  isRescheduleFlow,
  queryParams,
  openedBy
}) => {
  if (!(0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiStaff)(service) || (0, _bookingsCalendarCatalogViewerMapper.isCustomerCannotChooseStaff)(bookingsSettings) && !(0, _bookingsCalendarCatalogViewerMapper.isStaffVariant)(serviceOptionsAndVariants) || (0, _getQueryParams.getResourceFromUrl)(queryParams)) {
    return DisplayTarget.NONE;
  }
  if (isRescheduleFlow || (0, _bookingsCalendarCatalogViewerMapper.isCalendarWidget)(openedBy)) {
    return DisplayTarget.CALENDAR;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isStaffSelectionBeforeSlot)(bookingsSettings)) {
    return DisplayTarget.PREFERENCES_MODAL;
  }
  return DisplayTarget.CALENDAR;
};
const calculateLocationDisplay = ({
  service,
  bookingsSettings,
  isRescheduleFlow,
  openedBy,
  queryParams
}) => {
  if (isRescheduleFlow || !(0, _bookingsCalendarCatalogViewerMapper.isServiceWithMultiBusinessLocations)(service) || (0, _getQueryParams.getLocationFromUrl)(queryParams)) {
    return DisplayTarget.NONE;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isCalendarWidget)(openedBy)) {
    return DisplayTarget.CALENDAR;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || (0, _bookingsCalendarCatalogViewerMapper.isLocationSelectionBeforeSlot)(bookingsSettings)) {
    return DisplayTarget.PREFERENCES_MODAL;
  }
  return DisplayTarget.CALENDAR;
};
const calculateDynamicPriceDisplay = ({
  addOnsDisplay,
  bookingsSettings,
  serviceOptionsAndVariants,
  isRescheduleFlow,
  openedBy
}) => {
  if (isRescheduleFlow) {
    return DisplayTarget.NONE;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isDurationVariant)(serviceOptionsAndVariants)) {
    return DisplayTarget.PREFERENCES_MODAL;
  }
  if ((0, _bookingsCalendarCatalogViewerMapper.isCustomVariant)(serviceOptionsAndVariants)) {
    if ((0, _bookingsCalendarCatalogViewerMapper.isCalendarWidget)(openedBy)) {
      return DisplayTarget.CALENDAR;
    }
    if ((0, _bookingsCalendarCatalogViewerMapper.isMultiServiceAppointment)(bookingsSettings) || addOnsDisplay === DisplayTarget.PREFERENCES_MODAL) {
      return DisplayTarget.PREFERENCES_MODAL;
    }
    return DisplayTarget.CALENDAR;
  }
  return DisplayTarget.NONE;
};
const calculateAddOnsDisplay = ({
  service,
  isRescheduleFlow
}) => {
  if (isRescheduleFlow) {
    return DisplayTarget.NONE;
  }
  return (0, _bookingsCalendarCatalogViewerMapper.isServiceWithAddOns)(service) ? DisplayTarget.PREFERENCES_MODAL : DisplayTarget.NONE;
};
//# sourceMappingURL=calculatePreferencesView.js.map